/** @format */

export const totalTransferColumn = [
  {
    key: "bankName",
    label: "農協名",
    align: "left",
    cellProps: {
      minWidth: 20,
      width: "15%",
    },
  },
  {
    key: "regionName",
    label: "地域",
    align: "left",
    cellProps: {
      minWidth: 20,
      width: "75%",
    },
  },
  {
    key: "total",
    label: "振込額",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "10%",
    },
    render: item => new Intl.NumberFormat().format(item?.total.toFixed(0)),
  },
];

export const transferColumn = [
  {
    key: "bankName",
    label: "農協名",
    align: "left",
    cellProps: {
      minWidth: 20,
      width: "15%",
    },
    rowCellPropsByItem  : (item) => item.isPastPayment ? {backgroundColor: "#ff8f8f"} : null,
  },
  {
    key: "bankBranchName",
    label: "支所名",
    align: "left",
    cellProps: {
      minWidth: 20,
      width: "10%",
    },
    rowCellPropsByItem  : (item) => item.isPastPayment ? {backgroundColor: "#ff8f8f"} : null,
  },
  {
    key: "totalTransfer",
    label: "支所小計",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "10%",
    },
    rowCellPropsByItem  : (item) => item.isPastPayment ? {backgroundColor: "#ff8f8f"} : null,
    render: item => {
      return typeof item.totalTransfer === "number"
        ? new Intl.NumberFormat().format(item?.totalTransfer)
        : item.totalTransfer;
    },
  },
  {
    key: "commodityOwnerCd",
    label: "荷主コード",
    align: "left",
    cellProps: {
      minWidth: 20,
      width: "10%",
    },
    rowCellPropsByItem  : (item) => item.isPastPayment ? {backgroundColor: "#ff8f8f"} : null
  },
  {
    key: "commodityOwnerName",
    label: "荷主名",
    align: "left",
    cellProps: {
      minWidth: 20,
      width: "28%",
    },
    rowCellPropsByItem  : (item) => item.isPastPayment ? {backgroundColor: "#ff8f8f"} : null
  },
  {
    key: "accountNumber",
    label: "口座番号",
    align: "left",
    cellProps: {
      minWidth: 20,
      width: "8%",
    },
    rowCellPropsByItem  : (item) => item.isPastPayment ? {backgroundColor: "#ff8f8f"} : null,
    render: ({ accountNumber }) => {
      const tempAccountNumber = `0000000${accountNumber}`;
      return tempAccountNumber.substring(tempAccountNumber.length - 7);
    },
  },
  {
    key: "transfer",
    label: "振込額",
    align: "right",
    cellProps: {
      minWidth: 20,
      width: "8%",
    },
    rowCellPropsByItem : (item) => item.isPastPayment ? {backgroundColor: "#ff8f8f"} : null,
    render: item => {
      return typeof item.transfer === "number"
        ? new Intl.NumberFormat().format(item?.transfer.toFixed(0))
        : item.transfer;
    },
  },
  {
    key: "lastPaymentDate",
    label: "最終\n支払日",
    align: "left",
    cellProps: {
      minWidth: 20,
      width: "8%",
    },
    rowCellPropsByItem : (item) => item.isPastPayment ? {backgroundColor: "#ff8f8f"} : null
  },
];
